<script setup lang="ts">
import { ref } from 'vue'
import { RouterView } from 'vue-router'
import { Spinner } from 'wepin-vue-component'
import { useFetchHandlers, useI18nTypes } from '@/composables'
import { useLoadingsStore, useUserAPIStore } from '@/stores'
import { loginUserQueryToken } from '@/utils'

const { t } = useI18nTypes()
const loadingsStore = useLoadingsStore()
const userAPIStore = useUserAPIStore()
const { loginSuccessHandler } = useFetchHandlers()

const renderRouterView = ref(false)

const init = async () => {
  try {
    // refreshToken이 없으면 초기화 생략
    const refreshToken = localStorage.getItem('refreshToken')
    if (!refreshToken) {
      renderRouterView.value = true
      return
    }

    await loginUserQueryToken()
    if (userAPIStore.isLoginUser()) {
      await loginSuccessHandler()
    }
  } catch (error) {
    // Error handled silently
  } finally {
    renderRouterView.value = true
  }
}

init()
</script>

<template>
  <RouterView v-if="renderRouterView" />
  <Teleport to="body">
    <Spinner
      :is-loading="loadingsStore.loading"
      :text="t(loadingsStore.loadingMsg)"
      version="v2"
    />
  </Teleport>
</template>
